import React from "react";
import ReactEcharts from "echarts-for-react";

export default function ChartComponent(props){
    return(
        <ReactEcharts 
        option={props.option}
        style={props.option} />
    );
}